import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { CreateSupplierRequestDTO } from '@infrastructure/suppliers/dto/SupplierDTO';

export const useSuppliers = () => {
  const queryClient = useQueryClient();

  const suppliersQuery = useQuery({
    queryKey: ['suppliers'],
    queryFn: async () => {
      const result = await container.supplierRepository.getSuppliers();
      if (result.status === 'error') {
        throw new Error(result.error.message);
      }
      return result.data;
    }
  });

  const createSupplierMutation = useMutation({
    mutationFn: async (supplier: CreateSupplierRequestDTO) => {
      const result = await container.supplierRepository.createSupplier(supplier);
      if (result.status === 'error') {
        throw new Error(result.error.message);
      }
      return result.data;
    },
    onSuccess: () => {
      // Invalidate and refetch suppliers list
      queryClient.invalidateQueries({ queryKey: ['suppliers'] });
    }
  });

  return {
    suppliers: suppliersQuery.data || [],
    isLoading: suppliersQuery.isLoading,
    error: suppliersQuery.error,
    createSupplier: createSupplierMutation.mutateAsync,
    isCreating: createSupplierMutation.isLoading,
  };
}; 